<template>
  <div>
    <HeadersMain />
    <main>
      <slot />
    </main>
    <LazyFootersMain hydrate-on-visible />
  </div>
</template>
